import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material';
import { Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { CertificadosService } from 'src/app/services/certificados.service';
var SolicitanteComponent = /** @class */ (function () {
    function SolicitanteComponent(fb, _userService, _CertificadosService, rutValidator, dialog) {
        this.fb = fb;
        this._userService = _userService;
        this._CertificadosService = _CertificadosService;
        this.rutValidator = rutValidator;
        this.dialog = dialog;
        this.rows = [];
        this.matcher = new FormService();
        this.rut_sol = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("solicitantes"))) {
            localStorage.setItem("solicitantes", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("solicitantes"));
        }
        this.invalidRut = true;
        this.solicitante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
    }
    SolicitanteComponent.prototype.get_solicitante = function (rut, soloVer) {
        var _this = this;
        this._CertificadosService.getSolicitante(rut).subscribe(function (response) {
            console.log(response);
            if (response.message) {
                _this.solicitante.rut = rut ? rut : '';
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.solicitante.rut = response.rut ? response.rut : '';
                _this.solicitante.nombre = response.nombre ? response.nombre : '';
                _this.solicitante.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.solicitante.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.solicitante.direccion = response.direccion ? response.direccion : '';
                _this.solicitante.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.solicitante.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.solicitante.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.solicitante.comuna = response.comuna ? response.comuna : '';
                _this.solicitante.fono = response.fono ? response.fono : '';
                _this.solicitante.fax = response.fax ? response.fax : '';
                _this.solicitante.mail = response.mail ? response.mail : '';
                _this.solicitante.recordId = response.recordId ? response.recordId : '';
                if (soloVer) {
                    _this.dialog.open(_this.openModalVer);
                }
                else {
                    _this.dialog.open(_this.openModal);
                }
            }
        }, function (error) {
            console.log(error);
        });
    };
    SolicitanteComponent.prototype.cleanData = function () {
        this.solicitante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
        this.rut_sol.reset();
    };
    SolicitanteComponent.prototype.saveSolicitante = function () {
        var _this = this;
        this._CertificadosService.saveSolicitante(this.solicitante).subscribe(function (response) {
            console.log(response);
            if (response.update || response.save) {
                $("#prop_modal").modal("hide");
                _this.actualRow = localStorage.getItem("solicitantes");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.solicitante.rut,
                    nombre: _this.solicitante.nombre,
                    apellido_pat: _this.solicitante.apellido_pat,
                    apellido_mat: _this.solicitante.apellido_mat,
                    direccion: _this.solicitante.direccion,
                    direccion_num: _this.solicitante.direccion_num,
                    direccion_complemento: _this.solicitante.direccion_complemento,
                    direccion_completa: _this.solicitante.direccion_completa,
                    comuna: _this.solicitante.comuna,
                    fono: _this.solicitante.fono,
                    fax: _this.solicitante.fax,
                    mail: _this.solicitante.mail,
                    recordId: _this.solicitante.recordId
                });
                localStorage.setItem("solicitantes", JSON.stringify(_this.rows));
                _this.solicitante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' };
                _this.rut_sol.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            console.log(error);
        });
    };
    SolicitanteComponent.prototype.delete_solicitante = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("solicitantes", JSON.stringify(this.rows));
            }
        }
    };
    return SolicitanteComponent;
}());
export { SolicitanteComponent };
